import React, { Fragment } from 'react';

import { Grid, TextField } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';

function RemoveDuplicateValues({
  availablePlaceholders,
  onPlaceholderSelected,
  duplicateList,
  index,
}) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Remove all duplicate values from this list.
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          placeholders={availablePlaceholders}
          onPlaceholderSelected={onPlaceholderSelected}
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'duplicateList');
            return true;
          }}
          placeholder="Insert a list "
          inputValue={duplicateList}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'duplicateList')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'duplicateList')}
        />
      </Grid>
    </Fragment>
  );
}

export default RemoveDuplicateValues;
